var map = {
	"./black.gif": 16633,
	"./blue.gif": 8132,
	"./brown.gif": 3420,
	"./green.gif": 80641,
	"./orange.gif": 99346,
	"./white.gif": 26523,
	"./yellow.gif": 90400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44219;